module.exports = __webpack_public_path__ + "icons.svg";